import { SanityFullWidthTeaser } from '../../types/generated/graphql-types'
import { FullWidthTeaserProps } from '../components/blocks/FullWidthTeaser'
import { Breakpoints } from '../utilities/breakpoints'
import { validImage } from '../utilities/filters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import { Translations } from '../utilities/localization'
import { isNullOrWhiteSpace } from '../utilities/string'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const mapSanityFullWidthTeaserToFullWidthTeaserProps = (
  { buttonLabel, image, link, text, title }: SanityFullWidthTeaser,
  translations: Translations
): FullWidthTeaserProps => {
  const linkProps = link ? mapSanityLinkToInternalExternalLink(link) : undefined

  if (linkProps) {
    if (!isNullOrWhiteSpace(buttonLabel)) {
      linkProps.title = buttonLabel
    }

    if (isNullOrWhiteSpace(linkProps.title)) {
      linkProps.title = translations.learnMore ?? ''
    }
  }

  return {
    link: linkProps,
    title: title ?? undefined,
    text: text ?? undefined,
    image: validImage(image)
      ? getImagePropsWithSources(
          image,
          {
            small: Presets.fullWidthTeaser.small,
            medium: Presets.fullWidthTeaser.medium,
            large: Presets.fullWidthTeaser.large,
            extraLarge: Presets.fullWidthTeaser.extraLarge,
          },
          Breakpoints.tb,
          Breakpoints.lg,
          Breakpoints.xxl
        )
      : undefined,
  }
}
